// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"25c4f63d","238":"f7a8081a","239":"b966d37e","453":"478e5375","455":"ac05b973","557":"fabd2992","762":"864c7db2"}[chunkId] + ".chunk.js";
};